/**
 * Manages UI interactions for the DesktopViewPanel, including the context menu,
 * unsupported control tooltips, and click handlers.
 */
import React, { useState, useEffect, useCallback } from 'react';

export const usePanelInteractions = (selectedControlId, selectControl) => {
    const [menuState, setMenuState] = useState({ visible: false, x: 0, y: 0, options: [] });
    const [tooltip, setTooltip] = useState({ visible: false, content: '', x: 0, y: 0 });

    // Hide tooltip if the selection is cleared elsewhere
    useEffect(() => {
        if (!selectedControlId) {
            setTooltip(prev => ({ ...prev, visible: false }));
        }
    }, [selectedControlId]);

    const showMenu = useCallback((x, y, options) => setMenuState({ visible: true, x, y, options }), []);
    const hideMenu = useCallback(() => setMenuState(prev => ({ ...prev, visible: false })), []);
    const hideTooltip = useCallback(() => setTooltip({ visible: false, content: '', x: 0, y: 0 }), []);

    const handleControlClick = (event, control) => {
        event.stopPropagation();
        const isSelected = selectedControlId === control.id;
        selectControl(isSelected ? null : control.id);

        if (!isSelected && !control.isDraggable) {
            const content = <><b>{control.name}</b> is not supported in mobile.</>;
            setTooltip({ visible: true, content, x: event.pageX, y: event.pageY });
        } else {
            hideTooltip();
        }
    };

    const handlePanelClick = () => {
        hideMenu();
        hideTooltip();
    };

    return {
        menuState,
        tooltip,
        showMenu,
        hideMenu,
        hideTooltip,
        handleControlClick,
        handlePanelClick,
    };
};